"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ai = exports.styleLinkText = exports.styleLabelText = exports.injectStopPropagation = exports.defaultTermsAndPrivacyOptIn = exports.defaultSmsOptIn = exports.getQuestions = exports.getCardStyle = exports.getButtonStyle = exports.generateSurveyConfig = void 0;
var generateSurveyConfig_1 = require("./generateSurveyConfig");
Object.defineProperty(exports, "generateSurveyConfig", { enumerable: true, get: function () { return generateSurveyConfig_1.generateSurveyConfig; } });
var helpers_1 = require("./helpers");
Object.defineProperty(exports, "getButtonStyle", { enumerable: true, get: function () { return helpers_1.getButtonStyle; } });
Object.defineProperty(exports, "getCardStyle", { enumerable: true, get: function () { return helpers_1.getCardStyle; } });
Object.defineProperty(exports, "getQuestions", { enumerable: true, get: function () { return helpers_1.getQuestions; } });
var optIns_1 = require("./optIns");
Object.defineProperty(exports, "defaultSmsOptIn", { enumerable: true, get: function () { return optIns_1.defaultSmsOptIn; } });
Object.defineProperty(exports, "defaultTermsAndPrivacyOptIn", { enumerable: true, get: function () { return optIns_1.defaultTermsAndPrivacyOptIn; } });
Object.defineProperty(exports, "injectStopPropagation", { enumerable: true, get: function () { return optIns_1.injectStopPropagation; } });
Object.defineProperty(exports, "styleLabelText", { enumerable: true, get: function () { return optIns_1.styleLabelText; } });
Object.defineProperty(exports, "styleLinkText", { enumerable: true, get: function () { return optIns_1.styleLinkText; } });
__exportStar(require("./types"), exports);
exports.ai = __importStar(require("./ai"));
//# sourceMappingURL=index.js.map